/// <reference path="../orgsearchbar/orgsearchbar.js" />
/*!

=========================================================
* Argon Dashboard PRO React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
import { useStore, setTenantCollection } from "../../utilities/appStore";
import Cookies from "../../utilities/AutoCookies";
import CookieKeys from "../../constants/cookies";

//import OrgSearchBar from "../../components/OrgSearchBar/OrgSearchBar";
import TenantDropdown from "../TenantDropdown/TenantDropdown";
import SearchDropdown from "../SearchDropdown/SearchDropdown";

function SimpleHeader({ name, parentName }) {
    let [searchTerm, setSearchTerm] = useState("");
    let [isLoading, setIsLoading] = useState(false);
    let [userIsAdmin, setUserIsAdmin] = useState(false);
    let [isAdminSearch, setIsAdminSearch] = useState(false);
    const org = useStore((state) => state.CurrentOrganization);
    const orgId = useStore((state) => state.CurrentOrganizationId);
    let userRoles = useStore((state) => state.UserRoles);
    let tenantCollection = useStore((state) => state.TenantCollection);
    let defaultTenantSelector = "";
    useEffect(() => {
        const fetchTenantCollection = async () => {
            if (!tenantCollection) {
                try {
                    const raw = Cookies.get(CookieKeys.TenantCollection);
                    if (raw) {
                        const parsed = JSON.parse(raw);
                        const isValid =
                            parsed &&
                            typeof parsed === 'object' &&
                            Object.values(parsed).every((item) =>
                                item &&
                                typeof item.accountId === 'number' &&
                                typeof item.name === 'string' &&
                                typeof item.createdDateTime === 'string' &&
                                typeof item.selected === 'boolean'
                            );

                        if (isValid) {
                            setTenantCollection(parsed);
                        } else {
                            console.warn('Invalid tenant structure in cookie:', parsed);
                        }
                    }
                } catch (error) {
                    console.error('Failed to parse user cookie:', error);
                }
            }
        }
        fetchTenantCollection();
    }, [tenantCollection])


    useEffect(() => {
        async function loadRoles() {
            if (userRoles.some(item => item.role === 3)) {
                setUserIsAdmin(true);
            }            
        }
        loadRoles();
    }, [userRoles]);

    let handleAdminSwitch = function () {
        setIsAdminSearch(!isAdminSearch);
    }
    if (tenantCollection) {
        defaultTenantSelector = Object.keys(tenantCollection).length <= 10 ?
            <TenantDropdown tenants={tenantCollection} /> :
            <SearchDropdown dataMap={tenantCollection} />
    }

    return (
        <>
            
                <div className="header header-dark bg-primary pb-6 content__title content__title--calendar">
                <Container fluid>

                    {isLoading &&
                        <Spinner className="centered-loader" />
                    } {!isLoading &&
                        <div className="header-body">
                            <Row>
                                <Col lg="3"></Col>
                                <Col className="organization-ddl-container">
                                    {/*<UncontrolledDropdown group>*/}
                                    {/*    <Button color="white" className="org-select-ddl">*/}
                                    {/*        Organization: {organizationName}*/}
                                    {/*    </Button>*/}
                                    {/*    <DropdownToggle className="organization-ddl-chevron">*/}
                                    {/*        <FontAwesomeIcon icon={faChevronDown} />*/}
                                    {/*    </DropdownToggle>*/}
                                    {/*    <DropdownMenu>*/}
                                    {/*        <DropdownItem header>*/}
                                    {/*            Header*/}
                                    {/*        </DropdownItem>*/}
                                    {/*        <DropdownItem>*/}
                                    {/*            Some Action*/}
                                    {/*        </DropdownItem>*/}
                                    {/*        <DropdownItem text>*/}
                                    {/*            Dropdown Item Text*/}
                                    {/*        </DropdownItem>*/}
                                    {/*        <DropdownItem disabled>*/}
                                    {/*            Action (disabled)*/}
                                    {/*        </DropdownItem>*/}
                                    {/*        <DropdownItem divider />*/}
                                    {/*        <DropdownItem>*/}
                                    {/*            Foo Action*/}
                                    {/*        </DropdownItem>*/}
                                    {/*        <DropdownItem>*/}
                                    {/*            Bar Action*/}
                                    {/*        </DropdownItem>*/}
                                    {/*        <DropdownItem>*/}
                                    {/*            Quo Action*/}
                                    {/*        </DropdownItem>*/}
                                    {/*    </DropdownMenu>*/}
                                    {/*</UncontrolledDropdown>*/}
                                    {/*{userIsAdmin &&*/}
                                    {/*    <>*/}
                                    {/*        {isAdminSearch ? (<FontAwesomeIcon icon={faSquareCheck} onClick={handleAdminSwitch} size="2x" />) : (<FontAwesomeIcon icon={faSquare} onClick={handleAdminSwitch} size="2x" />)}*/}
                                    {/*        <span className="search-all-text">Search All Organizations</span>*/}
                                    {/*    </>*/}
                                    {/*}*/}
                                </Col>
                                <Col lg="3"></Col>
                            </Row>
                            <Row className="org-search-row">


                                <Col className="col-4">
                                    {defaultTenantSelector}
                                </Col>
                              
                                <Col className="col-4"></Col>
                            </Row>
                        </div>
                    }
                    </Container>
                </div>
        </>
    );
}

SimpleHeader.propTypes = {
    name: PropTypes.string,
    parentName: PropTypes.string,
};

export default SimpleHeader;
